<template>
    <div class="accordion-wrapper themed-scrollbar">
        <ul v-if="faqsList.length" class="simple-accordion" ref="faqAccordion" id="faqAccordion">
            <li v-for="item in faqsList" :key="item.id" class="accordion-item" :class="{'open' : item.open}" @click.prevent="item.open = !item.open">
                <p class="item-name"> {{ item.title }} </p>
                <transition enter-active-class="enter-active"
                            leave-active-class="leave-active"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @after-enter="afterEnter"
                            @before-leave="beforeLeave"
                            @leave="leave"
                            @after-leave="afterLeave">
                    <p v-show="item.open" v-html="item.content" class="item-content" />
                </transition>
                <i :class="{'ecom-chevron-down' : !item.open, 'ecom-chevron-down rotate' : item.open}" />
            </li>
        </ul>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'FaqAccordion',
    components: {},
    props: {},
    data() {
        return {
            faqsList: []
        }
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        faqsContent() {
            return this.$store.getters.faqs;
        },
        /*faqsList() {
            let listParsed = [];
            if(!isEmpty(this.faqsContent)) {
                this.faqsContent.forEach(faq => {
                    let elm = {
                        id: faq.faqId,
                        title: faq.question,
                        content: faq.answer,
                        open: false
                    };
                    listParsed.push(elm);
                });
                
            }
            
            return listParsed;
        }*/
    },
    watch: {},
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            if(!isEmpty(this.faqsContent)) {
                this.faqsContent.forEach(faq => {
                    let elm = {
                        id: faq.faqId,
                        title: faq.question,
                        content: faq.answer,
                        open: false
                    };
                    this.faqsList.push(elm);
                });

            }
        });
    },
    methods: {
        // for accordion transitions with dynamic content
        /**
         * @param {HTMLElement} element
         */
        beforeEnter(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = '0px';
                }

                element.style.display = null;
            });
        },
        /**
         * @param {HTMLElement} element
         */
        enter(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = `${element.scrollHeight}px`;
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterEnter(element) {
            element.style.height = null;
        },
        /**
         * @param {HTMLElement} element
         */
        beforeLeave(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = `${element.offsetHeight}px`;
                }
            });
        },
        /**
         * @param {HTMLElement} element
         */
        leave(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = '0px';
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterLeave(element) {
            element.style.height = null;
        },
    }
};
</script>

<style scoped>

</style>